// extracted by mini-css-extract-plugin
export default {"headerImage":"BannersList_headerImage__uDJ6U"};